package com.milta.feature.profile.data.remote.dto

import kotlinx.serialization.Serializable

/** Response of GET /profile/link-code (MIL-49) — idempotent, Driver-only. */
@Serializable
data class LinkCodeResponse(val code: String)
